<app-error *ngIf="error"></app-error>
<div class="container-filter">
  <!--<div>
    <app-warning-message
      style="padding-bottom: 15px;"
      [messageTitle]="
        'Momentáneamente las liquidaciones de pensión no están disponibles. El sistema se encuentra en mantención.'
      "
      [message]="
        'Puedes solicitarlas a través de contactovida@security.cl. Lamentamos las molestias que esto pudiera ocasionar.'
      "
    ></app-warning-message>
  </div>-->
  <!--UH-6508-Eliminacion texto liquidaciones en mantencion-->
  <div class="wrap-titulo">
    <label>Selecciona el período a desplegar y presione buscar:</label>
  </div>
  <div class="wrap-filter vertical-flex">
    <div class="responsive-row">
      <div class="data-pair">
        <app-form-select
          class="select-periodo-liquidacion"
          [label]="'Período'"
          [(ngModel)]="selectedPeriod"
          [options]="periodos"
          [optionValue]="'Anno'"
          [optionDescription]="'Anno'"
          [hasError]="false"
          [width]="screenSize == 'sm' || screenSize == 'xs' ? '100%' : '150px'"
          [ngStyle]="{
            'padding-right.px':
              screenSize == 'sm' || screenSize == 'xs' ? 0 : 38
          }"
        >
        </app-form-select>
      </div>

      <div class="data-pair-md">
        <button
          [disabled]="!selectedPeriod"
          class="button-class"
          mat-flat-button
          (click)="getLiquidaciones()"
          [ngStyle]="{
            width:
              screenSize === 'sm' || screenSize === 'xs' ? '100%' : ' 108px'
          }"
        >
          Buscar
        </button>
      </div>
    </div>
  </div>

  <!-- <mat-card>
    <mat-card-content>
      <div class="error" *ngIf="error">
        Ha ocurrido un error. Reintente más tarde.
      </div>

      <div style="width: 12.5rem">
        <app-form-select
          [label]="'PERIODO'"
          [(ngModel)]="selectedPeriod"
          [options]="periodos"
          [optionValue]="'Anno'"
          [optionDescription]="'Anno'"
        >
        </app-form-select>
      </div>

      <div class="info" *ngIf="!error && data?.length == 0">
        No existen liquidaciones.
      </div>

      <br />

      <div>
        <button
          [disabled]="!selectedPeriod"
          mat-flat-button
          (click)="getLiquidaciones()"
        >
          Buscar
        </button>
      </div>
    </mat-card-content>
  </mat-card> -->
</div>

<div style="margin-top: 20px">
  <div class="info" *ngIf="!error && cardSelectedPeriod && data?.length <= 0">
    No existen datos.
  </div>

  <app-colapsable
    *ngIf="data?.length > 0"
    [title]="'LIQUIDACIONES ' + cardSelectedPeriod"
    ($expandedChange)="expandChange()"
  >
    <div body>
      <app-table
        [theme]="1"
        [displayedColumns]="displayedColumns"
        [datasource]="dataTable"
        (iconClick$)="onIconClick($event)"
      ></app-table>
    </div>
  </app-colapsable>
</div>
